function formatPhoneNumber(phoneNumber) {
  // Remove any non-numeric characters (including spaces, dashes, etc.)
  let formattedNumber = phoneNumber.replace(/\D/g, "");

  // Check if the number doesn't start with a '0' and add it if needed
  if (formattedNumber && !formattedNumber.startsWith("0")) {
    formattedNumber = "0" + formattedNumber;
  }



  return formattedNumber;
}

export default formatPhoneNumber;